<template>
    <veui-icon :name="name"></veui-icon>
</template>

<script>
import 'veui-theme-one-icons';
import {Icon} from 'veui';

export default {
    props: {
        name: String
    },
    components: {
        'veui-icon': Icon
    }
};
</script>